import { focusRingStyles } from '@beacon/ui/styles';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon } from './Icon';

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={focusRingStyles({
      className: twMerge(
        'peer border-stroke-2 bg-surface-1 size-4 shrink-0 rounded-[4px] border transition-colors',
        'data-[state=checked]:border-primary-9 data-[state=checked]:bg-primary-9 data-[state=checked]:text-[#1A0A06]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      ),
    })}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      <Icon symbol="checkbox-check" className="size-3.5" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
